
function initFilm(){
 const video=document.getElementById('ldf-hero-video'),button=document.querySelector('.ldf-film-toggle');
 if(!video||!button||video.dataset.chVideoBound)return;
 video.dataset.chVideoBound="true";
 let userPaused=false,pending=false;
 video.defaultMuted=true;video.muted=true;video.autoplay=true;video.loop=true;video.playsInline=true;
 video.setAttribute('muted','');video.setAttribute('autoplay','');video.setAttribute('playsinline','');video.setAttribute('webkit-playsinline','');
 video.preload='auto';
 function label(){button.setAttribute('aria-label',document.documentElement.lang==='en'?(video.paused?'Play video':'Pause video'):(video.paused?'Lire la vidéo':'Mettre la vidéo en pause'));button.firstElementChild.textContent=video.paused?'▶':'Ⅱ';}
 function eligible(){const rect=video.getBoundingClientRect();return !userPaused&&!document.hidden&&!!video.closest('.page.active')&&rect.width>0&&rect.height>0&&rect.bottom>0&&rect.top<window.innerHeight;}
 function sync(){
  if(!eligible()){video.pause();return;}
  if(pending||!video.paused)return;
  video.muted=true;pending=true;
  const play=video.play();
  if(play&&play.then)play.then(()=>{pending=false;if(!eligible())video.pause();label();}).catch(()=>{pending=false;label();});
  else{pending=false;label();}
 }
 button.addEventListener('click',()=>{userPaused=!video.paused;sync();label();});
 ['play','pause'].forEach(event=>video.addEventListener(event,label));
 ['loadedmetadata','loadeddata','canplay'].forEach(event=>video.addEventListener(event,sync));
 document.addEventListener('visibilitychange',sync);
 window.addEventListener('pageshow',sync);
 window.addEventListener('hashchange',()=>requestAnimationFrame(sync));
 window.addEventListener('resize',sync,{passive:true});
 if('IntersectionObserver' in window)new IntersectionObserver(sync,{threshold:0}).observe(video);
 else window.addEventListener('scroll',sync,{passive:true});
 // Retry when Safari requires a user interaction; explicit pause is always respected.
 ['touchend','pointerup','keydown'].forEach(event=>document.addEventListener(event,e=>{if(!button.contains(e.target))sync();},{passive:true}));
 document.addEventListener('ch:language',label);
 label();sync();requestAnimationFrame(sync);window.addEventListener("load",sync,{once:true});[250,900,1800].forEach(delay=>setTimeout(sync,delay));
}
window.CHInitFilm=initFilm;initFilm();
